// extracted by mini-css-extract-plugin
export default {"container":"ForgetPasswordc_container__xrWuL"};